import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import Typewriter from 'typewriter-effect';
import g from './home.gif'
import './home.css'
const Home = () => {
    const url = "https://drive.google.com/file/d/1KTcmHaa8kZt5bUANEyEubVovxzw3yCGU/view?usp=sharing";
    const id1 = 'B002RL8IYK';
    const id2 = 'B01LD4MGY4';
    const id3 = 'NGYTDPOIP';
    return (
        <div className='home'>
            <header className="hero">
                <h1 className="hero-text ">
                    Hi, I am
                    <span className='ps-2 aq'> <Typewriter
                        options={{
                            strings: ['SIFAT', 'PASSIONATE', 'DILIGENT', 'a TECH ENTHUSIAST', 'a MERN DEVELOPER'],
                            autoStart: true,
                            loop: true,
                        }}
                    /></span>
                </h1>
                <img src={g} alt="" height='450' className='gif' />

                <p className="h-sub-text">
                    Ambitious problem-solving enthusiast leveraging powerful set of technology skills. I am a capable team player
                    and a quick learner who is eager to work with knowledgeable experts in a professional environment.
                </p>
                <div className="icons">
                    <Link to="/" className="icon-holder">
                        <FontAwesomeIcon icon={faLinkedin} className="icon fb" />
                    </Link>
                    <Link to="/" className="icon-holder">
                        <FontAwesomeIcon icon={faGithub} className="icon gh" />
                    </Link>
                    {/* <Link to="test" className="icon-holder">
                        <FontAwesomeIcon icon={faYoutube} className="icon yt" />
                    </Link> */}
                </div>
            </header>
            <Container className="text-center qq">
                <a target="_blank" rel="noopener noreferrer" href={url}> <button className="btn">Download Resume</button></a>
            </Container>
            <Container className='mt-5'>
                <div className="Title my-5">
                    <h3>Top Works
                        <span> Projects</span>
                    </h3>
                </div>
                <Row className='mb-5'>
                    <Col xs={12}>
                        <Card className='c cb w-100'>
                            <div className="image-data">
                                <Card.Img variant="top" src="https://i.ibb.co/dP54vwf/5.png" />
                                <Card.Body>
                                    <Card.Title className='text-center'>Travel~Mama</Card.Title>
                                    <Card.Text className='text-center fs-6'>
                                        For city dwellers its hard to find the perfect spot for vacation.Why the name Travel-MAMA ? So that the happiness off traveling starts just from hearing our name!
                                    </Card.Text>
                                </Card.Body>
                                <ul className="hover-items">
                                    <li>
                                        <a target="_blank" rel="noopener noreferrer" href='https://tour-front.web.app/'>Live</a>
                                        <NavLink to={`/details/${id1}`}>Details</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </Card>
                    </Col>
                    <Col xs={12} className='my-5'>
                        <Card className='c cb w-100'>
                            <Card.Img variant="top" src="https://i.ibb.co/BZwdFvP/7.png" />
                            <div className="image-data">
                                <Card.Body>
                                    <Card.Title className='text-center'>Tick~Tock</Card.Title>
                                    <Card.Text className='text-center fs-6'>
                                        "This is application for niche watches! For this project the Titan brand was targetted. This application brings you the limited edition Titan watches only for you!
                                    </Card.Text>
                                </Card.Body>
                                <ul className="hover-items">
                                    <li>
                                        <a target="_blank" rel="noopener noreferrer" href='https://titan-front.web.app/home'>Live</a>
                                        <NavLink to={`/details/${id2}`}>Details</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </Card>
                    </Col>
                    <Col >
                        <Card className='c cb w-100'>
                            <Card.Img variant="top" src="https://i.ibb.co/26mH0Vy/21.png" />
                            <div className="image-data">
                                <Card.Body>
                                    <Card.Title className='text-center'>News Express</Card.Title>
                                    <Card.Text className='text-center fs-6'>
                                        Clients can read the articles they want to read and have a nice chat in the comment section.Even the viewers can post a news that they want to share by signing in.  </Card.Text>

                                </Card.Body>
                                <ul className="hover-items">
                                    <li>
                                        <a target="_blank" rel="noopener noreferrer" href='https://salty-sea-00954.herokuapp.com/news'>Live</a>
                                        <NavLink to={`/details/${id3}`}>Details</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </Card>
                    </Col>

                </Row>
            </Container>
        </div >
    );
};

export default Home;